export const labels = {
	fontSizeTooltip: {
		label: "Label.MobileCreator.Tooltip.FontSize",
		default: "Font size",
	},
	decreaseFontSizeTooltip: {
		label: "Label.MobileCreator.Tooltip.DecreaseFontSize",
		default: "Decrease font size",
	},
	increaseFontSizeTooltip: {
		label: "Label.MobileCreator.Tooltip.IncreaseFontSize",
		default: "Increase font size",
	},
} as const;
